const runtime = require('./modules/runtime.js');
const util = require('util');

if (runtime.isBare()) {
    global.TextEncoder = util.TextEncoder;
    global.TextDecoder = util.TextDecoder;
}

const address = require('./modules/address.js');
const hash = require('./modules/hash.js');
const mnemonic = require('./modules/mnemonic.js');
const nonce = require('./modules/nonce.js');
const signature = require('./modules/signature.js');
const data = require('./modules/data.js');
const utils = require('./modules/utils.js');
const transaction = require('./modules/transaction.js');
const operation = require('./modules/operation.js');
const constants = require('./constants.js');

const sign = signature.sign;

module.exports = {
    address,
    hash,
    mnemonic,
    nonce,
    signature,
    data,
    utils,
    transaction,
    operation,
    sign,
    MAINNET_ID: constants.TRAC_NETWORK_MAINNET_ID,
    TESTNET_ID: constants.TRAC_NETWORK_TESTNET_ID,
};